import { Trans } from '@lingui/macro'
import { Box, Icon, IconButton, Tooltip } from '@mui/material'
import React from 'react'
import { FUNDING_PATHS } from 'app/views/funding/FundingConstants'

interface ReportActionsProps {
  id: string
  isEditable: boolean
  history: {
    push: (path: string) => void
  }
}

/**
* Renders action buttons for a grantee report.
* @component
* @category Reports
* @param {Object} props - Component properties
* @param {string} props.id - The ID of the report
* @param {boolean} props.isEditable - Whether the report is editable
* @param {Object} props.history - React Router history object
* @param {Function} props.history.push - Function to navigate to a different route
* @returns {React.FC} A React element containing action buttons for the report
* @description Displays either an edit or view icon button based on the editability of the report.
* Clicking the button navigates to the report detail page.
*/
const ReportActions: React.FC<ReportActionsProps> = ({ id, isEditable, history }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: {
          xs: 'flex-start',
          lg: 'flex-start'
        }
      }}
    >
      <Tooltip title={isEditable ? <Trans>EDIT</Trans> : <Trans>VIEW</Trans>}>
        <IconButton
          onClick={(e) => {
            history.push(`${FUNDING_PATHS.REPORT}/${id}`)
          }}
          size='large'
        >
          {isEditable
            ? (
              <Icon>edit</Icon>
              )
            : (
              <Icon>remove_red_eye</Icon>
              )}
        </IconButton>
      </Tooltip>
    </Box>
  )
}

export default ReportActions
